import React from "react";
import { Link } from "gatsby";
import LoginModal from "./LoginModal";

const rowClass = "flex min-h-[52px] w-full items-center justify-between border-b border-line text-lg font-medium text-ink";

const Label = ({ children }) => (
	<p className="mb-2.5 mt-0 text-[9px] font-extrabold uppercase leading-none tracking-eyebrow text-muted">{ children }</p>
);

/**
 * Menú desplegable de mobile. Con sesión abre con los accesos de cliente
 * (que en desktop viven en la barra superior) y después la navegación.
 */
const MobileMenu = ({ isOpen, items, isAuthenticated, hasPriceList, onSearchOpen, onLogout, onNavigate }) => {

	if (!isOpen) return null;

	return (
		<nav
			id="mobile-menu"
			className="absolute inset-x-0 top-full border-t border-line bg-white shadow-panel lg:hidden"
			aria-label="Menú móvil"
		>
			<div className="shell pb-8 pt-6">
				{
					isAuthenticated &&
						<>
							<Label>Accesos de cliente</Label>
							{
								hasPriceList &&
									<Link to="/lista-de-precios" className={ rowClass } onClick={ onNavigate }>Lista de precios</Link>
							}
							<button type="button" className={ rowClass } onClick={ onSearchOpen }>
								Buscar productos <span aria-hidden="true">→</span>
							</button>
							<div className="h-7"></div>
						</>
				}

				<Label>Explorar</Label>
				{
					items.map((item, index) => (
						<Link to={ item.href } key={ index } className={ rowClass } onClick={ onNavigate }>
							{ item.caption }
						</Link>
					))
				}

				<div className="h-7"></div>

				{
					isAuthenticated
						? (
							<button type="button" onClick={ onLogout } className={ `${rowClass} !text-[#8b2635]` }>
								Cerrar sesión
							</button>
						)
						: <LoginModal triggerClassName={ rowClass } />
				}
			</div>
		</nav>
	);
};

export default MobileMenu;
